import styled from "styled-components"

export default function OrderHistorySection({ onScroll, children }) {
  return <Section onScroll={onScroll}>{children}</Section>
}

const Section = styled.div`
  height: 100%;
  overflow-y: scroll;
`
